export const ErrorUnauthorized = 'ErrorUnauthorized';
export const ErrorForbidden = 'ErrorForbidden';